import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import SparePartsVehicleCard from "../../components/cards/SparePartsVehicleCard/SparePartsVehicleCard";
import vehiclesData from "../../data/vehiclesData";
import "./SparePartsPage.css";
import AftersalesSupportSection from "../../components/sections/AftersalesSupportSection/AftersalesSupportSection";
import { useTranslation } from "react-i18next";

export default function SparePartsPage() {
  const { t } = useTranslation();

  const vehiclesWithSpareParts = vehiclesData.filter(
    (vehicle) => vehicle.spareParts && vehicle.spareParts.length > 0
  );

  return (
    <div className="Page">
      <div className="sparePartsPageBanner text-center">
        <div className="page-banner-content">
          <h3>{t("sparePartsPage.bannerSubtitle")}</h3>
          <h1>{t("sparePartsPage.bannerTitle")}</h1>
        </div>
      </div>

      <Container fluid>
        <div className="section-spacing">
          <p className="brand-section-desc text-center mb-0">
            {t("sparePartsPage.tagline")}
          </p>
        </div>

        <Row className="gy-4">
          {vehiclesWithSpareParts.map((vehicle) => (
            <Col key={vehicle.id} xs={12} md={6} lg={4}>
              <SparePartsVehicleCard vehicle={vehicle} />
            </Col>
          ))}
        </Row>
      </Container>

      <div className="section-spacing-top">
        <AftersalesSupportSection />
      </div>
    </div>
  );
}